import React from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderText from '../Common/HeaderText';

const WorkshopHeader = () => {
  const navigate = useNavigate();

  return (
    <div className='flex flex-col tabletH:flex-row w-full min-w-0 items-start tabletH:justify-between gap-2 px-1 tabletH:px-[12px]'>
      <HeaderText label={'Workshop Bookings & Revenue'} />
      <button
        type='button'
        onClick={() => navigate('/admin/workshop/new')}
        className='mb-6 tabletH:mb-0 tabletH:mt-1 flex-shrink-0 rounded-lg bg-green-deep02 px-5 py-3 typo-b14Strong text-white hover:opacity-90'
      >
        + Create workshop
      </button>
    </div>
  );
};

export default WorkshopHeader;
